import { useQuery, useMutation, keepPreviousData } from "@tanstack/react-query";
import qs from "qs";
import api from "@services/api";

async function fetchOrderTypeDescriptions(filters, page, pageSize) {
  const query = qs.stringify(
    { ...filters, page, page_size: pageSize },
    { arrayFormat: "indices", encodeValuesOnly: true }
  );
  const { data } = await api.get(`/ww-order-type-description?${query}`);
  return data;
}

export function useOrderTypeDescriptionsQuery(filters, page, pageSize) {
  return useQuery({
    queryKey: ["orders", "order-type-description", filters, page, pageSize],
    queryFn: () => fetchOrderTypeDescriptions(filters, page, pageSize),
    placeholderData: keepPreviousData
  });
}

export function useOrderTypeDescriptionQuery(id) {
  return useQuery({
    queryKey: ["orders", "order-type-description", id],
    queryFn: async () => {
      const { data } = await api.get(`/ww-order-type-description/${id}`);
      return data;
    },
    enabled: !!id
  });
}

export function useCreateOrderTypeDescriptionMutation() {
  return useMutation({
    mutationFn: async (payload) => {
      const { data } = await api.post(`/ww-order-type-description`, payload);
      return data;
    }
  });
}

export function useSaveOrderTypeDescriptionMutation() {
  return useMutation({
    mutationFn: async ({ id, payload }) => {
      const { data } = await api.put(`/ww-order-type-description/${id}`, payload);
      return data;
    }
  });
}

export function useDeleteOrderTypeDescriptionMutation() {
  return useMutation({
    mutationFn: async (id) => {
      const { data } = await api.delete(`/ww-order-type-description/${id}`);
      return data;
    }
  });
}

